import React from "react";

/**
 * Long-form footer SEO block — keyword-dense narrative content positioned
 * after FAQ to round out the on-page SEO weight without dumping a wall of
 * text into the main flow.
 */
const BottomSeo = () => {
  return (
    <section
      id="bottom-seo"
      data-testid="bottom-seo"
      className="bg-[#FDFDFD] border-t-2 border-black py-20 sm:py-28"
      aria-labelledby="bottom-seo-h2"
    >
      <div className="max-w-[1100px] mx-auto px-6 sm:px-12">
        <h2
          id="bottom-seo-h2"
          data-testid="bottom-seo-title"
          className="font-display text-3xl sm:text-5xl lg:text-6xl font-black tracking-tighter uppercase leading-[0.95]"
        >
          Character AI Chat Online for{" "}
          <span className="relative inline-block">
            <span className="relative z-10">Roleplay, Stories</span>
            <span
              aria-hidden
              className="absolute left-0 bottom-1 sm:bottom-2 h-3 sm:h-4 w-full bg-[#FFD60A] -z-0"
            />
          </span>{" "}
          and Real Conversations
        </h2>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className="md:col-span-6 space-y-6 font-body text-base sm:text-lg leading-relaxed text-neutral-800">
            <p>
              Character AI chat online gives you a faster, more personal way
              to talk with virtual characters. Instead of chatting with a
              generic assistant, you can choose an AI character with a
              specific personality, emotional style and story background.
            </p>
            <p>
              Each conversation can become something different. One character
              might feel like a romantic companion. Another might act like a
              fantasy queen, anime friend, mysterious stranger, detective
              partner, villain or supportive AI companion. The point is
              simple: you are not just asking questions — you are building a
              conversation with a character that responds to your tone.
            </p>
          </div>

          <div className="md:col-span-6 space-y-6 font-body text-base sm:text-lg leading-relaxed text-neutral-800">
            <p>
              A great AI character chat should feel natural, fast and
              continuous. Your character should remember the context, follow
              the story, understand the mood and make every message feel
              connected to what came before. That is what makes character AI
              chat different from a normal chatbot.
            </p>
            <p>
              Whether you want roleplay, flirting, storytelling, emotional
              support, creative writing or late-night conversation, AI
              character chat lets you create the kind of interaction you
              want and return to it anytime.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BottomSeo;
